module.exports = __webpack_public_path__ + "img/icon-account.f055ee98.svg";